export default "__VITE_ASSET__YnZ_Wve$__"